import React, { useState } from 'react';
import BankSelection from './BankSelection';
import BankTransactionForm from './BankTransactionForm';
import './BankDeposit.css';

const BankDeposit = ({ onSuccess }) => {
  const [currentStep, setCurrentStep] = useState('selection');
  const [selectedBank, setSelectedBank] = useState(null);

  const handleBankSelect = (bank) => {
    setSelectedBank(bank);
    setCurrentStep('transaction');
  };

  const handleBack = () => {
    if (currentStep === 'transaction') {
      setCurrentStep('selection');
      setSelectedBank(null);
    }
  };

  const handleTransactionSubmit = () => {
    onSuccess();
  };

  return (
    <div className="bank-deposit">
      {currentStep === 'selection' && (
        <BankSelection onBankSelect={handleBankSelect} />
      )}
      
      {currentStep === 'transaction' && (
        <BankTransactionForm 
          bank={selectedBank}
          onSubmit={handleTransactionSubmit}
          onBack={handleBack}
        />
      )}
    </div>
  );
};

export default BankDeposit;